import React from "react";
import { styled } from "@emotion/styled";
import notfound from "./notfound.png";

function index() {
  return (
    <div>
      <img alt="not found" src={notfound} />
      <div>RIP, no such page</div>
    </div>
  );
}

export default index;
